(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('initSetupWizardEvent', {
                parent: 'app',
                url: '/initSetupWizardEvent',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup-event/init-setup-event.html',
                        controller: 'InitSetupEventController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
